module.exports = __webpack_public_path__ + "static/banner-4star-2fc95d96023bc5ec7b37b48fd71813e1.png";